import { render, staticRenderFns } from "./AccEventActivities.vue?vue&type=template&id=084b8531&"
import script from "./AccEventActivities.vue?vue&type=script&lang=js&"
export * from "./AccEventActivities.vue?vue&type=script&lang=js&"
import style0 from "./AccEventActivities.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports